export default "__VITE_ASSET__CfgdyF2F__"